import * as ActionTypes from "constants/ActionTypes";

const initialState = {
  jobs: [],
  count: 0,
  queueStatus: "completed",
  mediaTypeFilter: "all",
  isLoading: false,
  serviceError: null,
  serviceCode: 200,
};

export default function adminMediaProcessingJobsReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_START:
      return {
        ...state,
        isLoading: true,
        serviceError: null,
        queueStatus: action.status || state.queueStatus,
        mediaTypeFilter: action.mediaType || state.mediaTypeFilter,
      };

    case ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_SUCCESS: {
      const envelope = action.payload;
      if (envelope && envelope.statusCode === 200 && envelope.response) {
        const { jobs, count, status, media_type: mediaType } = envelope.response;
        return {
          ...state,
          isLoading: false,
          serviceError: null,
          serviceCode: envelope.statusCode,
          jobs: jobs || [],
          count: typeof count === "number" ? count : (jobs || []).length,
          queueStatus: status || state.queueStatus,
          mediaTypeFilter: mediaType || state.mediaTypeFilter,
        };
      }
      return {
        ...state,
        isLoading: false,
        serviceError: "Unexpected response",
        jobs: [],
        count: 0,
      };
    }

    case ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.error,
        jobs: [],
        count: 0,
      };

    default:
      return state;
  }
}
